import { render } from "./ReportStatDoctorsDatatableHtmlPerHourTotal.vue?vue&type=template&id=47376808"
import script from "./ReportStatDoctorsDatatableHtmlPerHourTotal.vue?vue&type=script&lang=js"
export * from "./ReportStatDoctorsDatatableHtmlPerHourTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__